import { isEmpty } from 'lodash';

const CACHE_KEY_CREATE = 'tp_form_cache_create';
const getEditCacheKey = (id) => `tp_form_cache_edit_${id}`;

const restoreDateRange = (dateRange) => {
  if (!Array.isArray(dateRange)) return dateRange;
  return dateRange.map((d) => (d ? new Date(d) : null));
};

const applyTalkingPointFormCache = (id) => {
  const isEdit = !isEmpty(id);
  const cacheKey = isEdit ? getEditCacheKey(id) : CACHE_KEY_CREATE;

  const saveCache = (values) => {
    try {
      localStorage.setItem(cacheKey, JSON.stringify(values));
    } catch (_) {}
  };

  const clearCache = () => {
    localStorage.removeItem(cacheKey);
  };

  const clearCacheForId = (targetId) => {
    const key = isEmpty(targetId) ? CACHE_KEY_CREATE : getEditCacheKey(targetId);
    localStorage.removeItem(key);
  };

  const getCache = () => {
    try {
      const raw = localStorage.getItem(cacheKey);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed?.displayDateRange) {
        parsed.displayDateRange = restoreDateRange(parsed.displayDateRange);
      }
      return parsed;
    } catch (_) {
      return null;
    }
  };

  return { saveCache, clearCache, clearCacheForId, getCache };
};

export default applyTalkingPointFormCache;
